export const RESET = 'GROUP_LIST_RESET'
export const SET_ITEMS = 'GROUP_LIST_SET_ITEMS'
export const SET_ERROR = 'GROUP_LIST_SET_ERROR'
export const SET_VIEW = 'GROUP_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'GROUP_LIST_TOGGLE_LOADING'
